import { useCurrencyCode } from "../hooks/useCurrencySymbol";
import { useFeature } from "./useFeature";

// Receive-only US SMS numbers (/utilities/sms). The backend has no partner
// gate and charges the USD monthly price straight from the account balance,
// so the feature is a partner flag combined with a USD-account guard. Used by
// both the nav item and the route registration so the two can't drift.
export const useSmsNumbersEnabled = (): boolean => {
  const enabled = useFeature("smsNumbers");
  const currencyCode = useCurrencyCode();

  return enabled && currencyCode === "USD";
};
